import styled from 'styled-components';

export const BgPurple = styled.div(
	({ theme: { down, breakpoints } }) => `
  
        ${down(breakpoints.md)} {
            padding: 25px;
        }
        position: relative;
        padding: 70px 100px;
        border-radius: 2px;
        * {
          z-index: 1;
          position: relative;
        }
        &:before {
          position: absolute;
          top: 0;
          left: 0;
          content: '';
          width: 100%;
          border-radius: 2px;
          height: calc(100% - 250px);
          background-image: linear-gradient(83deg, #723b63 2%, #4c2340 97%);
          z-index: 0;
        }
      `
);

export const CaseStudiesCardWrap = styled.div(
	({ theme: { down, breakpoints } }) => `
    display: flex;
    margin-top: 40px;
    flex-wrap: wrap;
    > article{
        width: calc(50% - 20px);
        margin-right: 20px;
        &:nth-child(2n){
            margin-right: 0;
        }
    }
  
        ${down(breakpoints.md)} {
            flex-wrap: wrap;
            > article{
                width: 100%;
                margin-right: 0px;
            }
        }
    
      `
);

export const ViewAllStoriesLink = styled.a`
  display: flex;
  justify-content: center;
  font-size: 16px;
  color: #0091ff;
  font-weight: 900;
  padding-top: 35px;
  > span {
    width: 0;
    height: 0;
    border-width: 4px;
    border-style: solid;
    border-bottom-color: transparent;
    border-left-color: transparent;
    position: relative;
    left: 40px;
    top: 6px;
    transform: rotate(45deg);
    &:before {
      right: 0;
      top: -1px;
      position: absolute;
      height: 1px;
      box-shadow: inset 0 0 0 32px;
      transform: rotate(-45deg);
      width: 35px;
      transform-origin: right top;
      content: "";
      box-sizing: border-box;
    }
  }
`;
